import { defineComponent, resolveComponent, createElementBlock, openBlock, Fragment, renderList, createBlock, resolveDynamicComponent, withCtx, createCommentVNode } from "vue";
import _sfc_main$1 from "./PrismicRichTextDefaultComponent.vue.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PrismicRichTextSerialize" },
  __name: "PrismicRichTextSerialize",
  props: {
    components: {},
    children: {},
    linkResolver: {}
  },
  setup(__props) {
    const CHILD_TYPE_RENAMES = {
      "list-item": "listItem",
      "o-list-item": "oListItem",
      "group-list-item": "list",
      "group-o-list-item": "oList"
    };
    const props = __props;
    function getComponent(child) {
      var _a;
      return ((_a = props.components) == null ? void 0 : _a[CHILD_TYPE_RENAMES[child.type] || child.type]) || _sfc_main$1;
    }
    return (_ctx, _cache) => {
      const _component_PrismicRichTextSerialize = resolveComponent("PrismicRichTextSerialize", true);
      return openBlock(true), createElementBlock(Fragment, null, renderList(props.children, (child) => {
        return openBlock(), createBlock(resolveDynamicComponent(getComponent(child)), {
          key: JSON.stringify(child),
          node: child.node,
          "link-resolver": getComponent(child) === _sfc_main$1 ? props.linkResolver : void 0
        }, {
          default: withCtx(() => [
            child.children.length ? (openBlock(), createBlock(_component_PrismicRichTextSerialize, {
              key: 0,
              children: child.children,
              components: _ctx.components,
              "link-resolver": _ctx.linkResolver
            }, null, 8, ["children", "components", "link-resolver"])) : createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["node", "link-resolver"]);
      }), 128);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PrismicRichTextSerialize.vue.js.map
